import React, { useState } from 'react';
import { Box, IconButton } from '@mui/material';
import { ReactComponent as FilterIcon } from '../../../assets/PepWise2.0/Filter - Icon - New.svg';
import AdvanceFilterOpsDrawer, { AdvancedFilterDrawerOpsProps } from './AdvanceFilterOpsDrawer';

type Props = AdvancedFilterDrawerOpsProps & {
  disabled?: boolean;
  clearText?: string;
  clearColor?: string;
  icon?: React.ReactNode;
};

export default function OpsAdvancedFilterPanel({
  open,
  onClose,
  onApply,
  onSaveDefault,
  onResetDefault,
  currentFilters,
  filterOptions,
  filterRelationshipRecords,
  setFilterOptions,
  originalfilterOptions,
  activeTile,
  activeParentTile,
  disabled = false,
  clearText = 'CLEAR FILTER',
  clearColor,
  icon,
}: Props) {
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(open);
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <IconButton
          onClick={() => setIsFilterDrawerOpen(true)}
          disabled={disabled}
          sx={{ position: 'relative', p: '0px !important' }}
        >
          {icon ?? <FilterIcon />}
        </IconButton>
      </Box>

      <AdvanceFilterOpsDrawer
        open={isFilterDrawerOpen}
        onClose={() => setIsFilterDrawerOpen(false)}
        onApply={onApply}
        onSaveDefault={onSaveDefault}
        onResetDefault={onResetDefault}
        currentFilters={currentFilters}
        filterOptions={filterOptions}
        setFilterOptions={setFilterOptions}
        originalfilterOptions={originalfilterOptions}
        activeTile={activeTile}
        activeParentTile={activeParentTile}
        filterRelationshipRecords={filterRelationshipRecords}
      />
    </Box>
  );
}